// extracted by mini-css-extract-plugin
export default {"page":"TCW9E","section":"t4Zpz","emptyState":"JZqUo"};